/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, selectionLimit: NonNullable<unknown> }} Mean_Dark_Rabbit_ZipInputs */

const en_mean_dark_rabbit_zip = /** @type {(inputs: Mean_Dark_Rabbit_ZipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select (${i?.count} / ${i?.selectionLimit})`)
};

const de_mean_dark_rabbit_zip = /** @type {(inputs: Mean_Dark_Rabbit_ZipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auswählen (${i?.count} / ${i?.selectionLimit})`)
};

/**
* | output |
* | --- |
* | "Select ({count} / {selectionLimit})" |
*
* @param {Mean_Dark_Rabbit_ZipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mean_dark_rabbit_zip = /** @type {((inputs: Mean_Dark_Rabbit_ZipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mean_Dark_Rabbit_ZipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mean_dark_rabbit_zip(inputs)
	return de_mean_dark_rabbit_zip(inputs)
});